export const populateCartAttributes = (
  productHandle,
  quantity,
  sellingPlanId,
  context,
  selectedFreeGift,
  upSell,
  selectedUpsellProductQuantity
) => {
  const cartAttributes = {
    'selling-plan-id': sellingPlanId,
    'is-subscription-builder-ready': true
  };

  if (productHandle) {
    cartAttributes[`${context}--${productHandle}--quantity`] = quantity;
  }

  if (context === 'machine') {
    cartAttributes['selected-machine-handle'] = productHandle;

    if (selectedFreeGift && selectedFreeGift.handle) {
      cartAttributes[`freegift--${selectedFreeGift.handle}`] = 1;
    }

    if (upSell && selectedUpsellProductQuantity) {
      cartAttributes[
        `upsell--${upSell.handle}--quantity`
      ] = selectedUpsellProductQuantity;
    }
  }

  return cartAttributes;
};
